<template>
  <div>
    <div class="homebot">
      <!-- <div class="footer-content">
        <img src="@/assets/img/footer-line.png" alt="" class="placeholder-img">
      <div class="platform-info flex flex-ac">
        <div class="flex-1 item">
          <div>{{ loginInfo.openbox_num }}</div>
          <div>已开启盲盒总数</div>
        </div>
        <div class="flex-1 item center">
          <div>{{ loginInfo.player_num }}</div>
          <div>已注册人数</div>
        </div>
        <div class="flex-1 item">
          <div>{{ loginInfo.online_num }}</div>
          <div>在线人数</div>
        </div>
      </div>
      </div> -->
      <ul class="list">
        <li v-for="(item, index) in routerList" :key="index">
          <span @click="fun(item.url)" class="link-name">{{ item.name }}</span>
          <span v-if="index!==(routerList.length-1)" class="line">|</span>
        </li>
      </ul>
      <div class="copyright">
        <div class="ba-right" style="margin: 12px 0;">copyright©2025 cs.all rights reserved</div>
        <div class="ba-right">
          <a href="https://beian.miit.gov.cn" target="_blank" style="color: #878787">闽ICP备2025105352号-1</a> | <a href="https://beian.miit.gov.cn" target="_blank" style="color: #878787">闽公网安备35020302036663号</a>
        </div>
      </div>
    </div>
    <RulePopup ref="RulePopup" />
  </div>

</template>

<script>
import RulePopup from "@/components/rule-popup.vue"

import { mapGetters } from 'vuex'
export default {
  components: { RulePopup },
  data() {
    return {
      routerList: [
        { name: "关于我们", url: "About" },
        { name: "用户协议", url: "UserAgreement" },
        { name: "隐私条款", url: "Privacy" },
        { name: "协议与条款", url: "TermsAndConditions" },
        { name: "常见问题", url: "CommonProblems" },
        { name: "概率公平性", url: "Fairness" },
        { name: "反洗钱协议", url: "AntiMoneyLaundering" }
      ],
      urlList: [],
      loginInfo: {
        player_num: 0,
        online_num: 0,
        openbox_num: 0
      }
    };
  },
  computed: {
    ...mapGetters([
      'setting'
    ])
  },
  created() {
    // this.getData()
  },
  methods: {
    fun(url) {
      this.$refs['RulePopup'].toggle(url)
    },
    goUrl(url) {
      window.open(url, "_blank");
    },
    goCase() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
    }
  },
};
</script>

<style lang="less" scoped>
.homebot {
  padding: 48px 0;
  //background: #2b2e3c;
  background: #1a1c24;
  .footer-content {
    .placeholder-img {
      width: 100%;
    }
    .platform-info {
      max-width: 800px;
      margin: 40px auto;
      color: #fff;
      text-align: center;
      .item {
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-direction: column;
        height: 100px;
        position: relative;
      }
      .center::before {
        display: block;
        content: '';
        width: 1px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        background-image: linear-gradient(
          hsla(0, 0%, 100%, 0.1),
          #ccc,
          hsla(0, 0%, 100%, 0.1)
        );
      }
      .center::after {
        display: block;
        content: '';
        width: 1px;
        height: 100px;
        position: absolute;
        top: 0;
        right: 0;
        background-image: linear-gradient(
          hsla(0, 0%, 100%, 0.1),
          #ccc,
          hsla(0, 0%, 100%, 0.1)
        );
      }
    }
  }
  .list {
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    color: #fff;
    li {
      margin-right: 10px;
      font-size: 12px;
      .link-name {
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
  .copyright {
    max-width: 800px;
    margin: 0 auto;
    .ba-right {
      text-align: center;
      color: #878787;
      font-size: 12px;
      cursor: pointer;
    }
    .top-right {
      margin-top: 20px;
      text-align: center;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #fff;
    opacity: 0.65;
    .top-left {
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          margin-top: 10px;
          margin-right: 32px;
          span {
            white-space: nowrap;
            display: inline-block;
          }
        }
        li:hover {
          cursor: pointer;
        }
      }
    }
    .top-right {
      margin-top: 10px;
      img {
        margin-right: 10px;
      }
    }
  }
  .bot {
    margin-top: 24px;
    display: flex;
    font-size: 14px;
    color: #515260;
    overflow-y: hidden;
    .bot-title {
      margin-right: 12px;
    }
    ul {
      display: flex;
      li {
        margin-right: 24px;
      }
      li:hover {
        cursor: pointer;
        text-decoration: underline;
        color: #e9b10e;
      }
    }
  }
}
</style>
